import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { FilterPatentInFolderService } from '@/modules/patent-folders-module/filter-patent-in-folder-service.interface';
export function useClickFolder() {
    function handleFolderClick(folder, patentNo) {
        const service = injectService(FilterPatentInFolderService);
        service.filter({
            spaceId: folder.spaceId,
            folderId: folder.folderId,
            patentNo,
        });
    }
    return {
        handleFolderClick,
    };
}
